import { EMPTY_PERMISSIONS, Permissions } from '../../auth/permissions';

export type AuthStatus = 'idle' | 'loading' | 'resolved' | 'rejected';

export interface IAuth {
    name: string;
    token: string;
    isLoggedIn: boolean;
    /** Display label only ('moderator' | 'user'), kept for logs and Print File Review. */
    role: string;
    /** Raw `cognito:groups` claim (decoded client-side, not verified). */
    allRoles: string[];
    /** UX gating only: what to show. The backend decides what is allowed. */
    permissions: Permissions;
}

export const EMPTY_AUTH: IAuth = {
    name: '',
    token: '',
    isLoggedIn: false,
    role: '',
    allRoles: [],
    permissions: EMPTY_PERMISSIONS,
};
